export default {
  cases: "Gevallen",
  case: "Geval",
  tour: "Tour",
  setup: "Setup",
  caseSetup: "Geval setup",
  builder: "Builder",
  pax: "Passagiers",
  contacts: "Contacten",
  bookings: "Boekingen",
  pricing: "Prijsstelling",
  preview: "Voorbeeld",
  tourBuilder: "Tour Builder",
  tourPax: "Tour Pax",
  tourContacts: "Tour Contacten",
  tourStatuses: "Tour Statussen",
  tourPricing: "Tour Prijsstelling",
  createTour: "Nieuwe tour maken",
  createTourText: "Weet u zeker dat u een nieuwe tour wilt maken voor dit geval?",
  archiveTour: "Tour archiveren",
  selectClient: "Selecteer klant",
  writeSearchClients: "Schrijf om te zoeken naar klanten",
  selectPax: "Selecteer pasagier",
  writeSearchPax: "Schrijf om te zoeken naar pasagiers",
  noCases: "Er zijn geen gevallen",
  createNewCase: "Maak een nieuw geval",
  archivedCases: "Gearchiveerde gevallen",
  activeCases: "Actieve gevallen",
  basicInformation: "Basisinformatie",
  caseDetails: "Geval details",
  archiveText: "U kunt een leverancier archiveren, als u dit doet verschijnt de leverancier niet in zoekopdrachten van de applicatie. U kunt deze zien in de lijst met leveranciers als u filtert op 'gearchiveerd'. Zodra u de details van een gearchiveerde leverancier bekijkt, kunt u deze definitief verwijderen of de archivering ongedaan maken.",
  media: "Media",
  noMedia: "Er zijn geen gekoppelde media",
  archivedText: "Deze leverancier is gearchiveerd, indien gewenst kunt u de archivering ongedaan maken door op de 'Herstellen' knop te klikken.",
  archiveCaseTitle: "Geval archiveren",
  archiveCaseText: "Weet je zeker dat je het geval '{case}' wilt archiveren? Als je het archiveert, zal het niet verschijnen in zoekopdrachten.",
  deleteText: "Deze leverancier is gearchiveerd, als u deze permanent wilt verwijderen, klik dan op de 'Verwijderen' knop. Let op dat als u deze verwijdert, de leverancier ophoudt te bestaan en niet kan worden hersteld.",
  deleteCaseTitle: "Geval verwijderen",
  deleteCaseText: "Weet je zeker dat je het geval '{case}' wilt verwijderen? Als je het verwijdert, kun je het niet meer herstellen.",
  restoreCaseTitle: "Geval herstellen",
  restoreCaseText: "Weet je zeker dat je het geval '{case}' wilt herstellen? Als je het herstelt, zal het niet langer gearchiveerd zijn en zal het verschijnen in de zoekopdrachten van de applicatie.",
  caseStatus: "Geval status",
  noContacts: "Er zijn geen gekoppelde contacten",
  editContactsBelongCaseText: "Bewerk contacten die bij het geval horen",
  addContacts: "Contacten toevoegen",
  removeContactTitle: "Contact van leverancier verwijderen",
  removeContactText: "Weet u zeker dat u '{contact}' als contact voor leverancier '{supplier}' wilt verwijderen?",
  quote: "Quote",
  statuses: "Statussen",
  duplicateTour: "Dubbele tour",
  duplicateCase: "Precase maken",
  copyCase: "Nieuwe versie",
  connectLuggage: "Bagage verbinden",
  duplicatedTourSuccess: "Hele tour succesvol gedupliceerd",
  redirectingNewTour: "Doorverwijzen naar de nieuwe tour...",
  duplicatedCaseSuccess: "Hele geval succesvol gedupliceerd",
  redirectingNewCase: "Doorverwijzen naar het nieuwe geval...",
  caseLogs: "Dossier Logboeken",
  noLogsFound: "Geen logboeken gevonden"
};
